import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  Col,
  Flex,
  Image,
  Row,
  Carousel,
  Skeleton,
  Tag,
  Empty
} from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { DescriptionList } from '../../../components';
import { dateFormat } from './utils/dateFormat';
import { detailsCards } from './utils/detailsCards';
import { useAuthContext } from '../../../contexts/AuthContext';
import { setMissingSupervisionsMessage } from './utils/setMissingSupervisionMessage';
import { convertToHTML } from '../../../utils/convertToHTML';
import { SupervisionStatus } from '../../../utils/constants/tagColors';

export const CardsList = ({ supervisions = [], isLoading, tabsKey }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user, token } = useAuthContext();

  if (!supervisions.length && !isLoading) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={setMissingSupervisionsMessage({ user, tabsKey, t })}
        style={{ padding: '48px 0' }}
      />
    );
  }

  return (
    <Skeleton
      loading={isLoading}
      active
      avatar={{ shape: 'square', size: 150 }}
    >
      <Flex vertical gap="middle" align="stretch">
        {supervisions.map((supervision) => (
          <React.Fragment key={supervision?._id}>
            <Card
              title={t(`supervisions.users_shows.supervision_date`, {
                reference: supervision?.reference,
                ...dateFormat(
                  supervision?.main_informations?.start_date,
                  supervision?.main_informations?.end_date,
                  user?.role
                )
              })}
              key={supervision?._id}
              hoverable
              onClick={() =>
                navigate(`/supervisions/details/${supervision?._id}`)
              }
              extra={
                <Tag color={SupervisionStatus[supervision?.status]}>
                  {t(`supervisions.tags.${supervision?.status}`)}
                </Tag>
              }
              className="supervision-list-card vet-card"
            >
              <Row gutter={[24, 16]}>
                {supervision?.summary?.anounce_photos?.length ? (
                  <Col xs={24} lg={6}>
                    <Carousel autoplay>
                      {supervision.summary.anounce_photos.map((photo) => (
                        <div key={photo}>
                          <Image
                            width={150}
                            src={`${process.env.REACT_APP_API_URL}/supervisions/get-url/${photo}/${token}`}
                            preview={false}
                          />
                        </div>
                      ))}
                    </Carousel>
                  </Col>
                ) : null}
                <Col
                  style={{ maxWidth: '100%' }}
                  xs={24}
                  lg={supervision?.summary?.anounce_photos?.length ? 18 : 24}
                >
                  <DescriptionList
                    data={detailsCards(tabsKey, t, supervision)}
                    withDivider
                    comment={convertToHTML({
                      htmlContent: supervision?.anounce?.description
                    })}
                    layout="horizontal"
                  />
                </Col>
              </Row>
            </Card>
          </React.Fragment>
        ))}
      </Flex>
    </Skeleton>
  );
};

CardsList.propTypes = {
  supervisions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isLoading: PropTypes.bool.isRequired,
  tabsKey: PropTypes.string
};

CardsList.defaultProps = {
  tabsKey: undefined
};
